<template>
<vs-row vs-justify="center">
    <vs-col class="ps_col_card">
        <vs-card class="ps_card">
            <form v-on:submit.prevent="login">
            <vs-row class="ps_row">
                <vs-col>
                    <vs-input placeholder="User" id="email" type="text" v-model="email"/>
                </vs-col>
            </vs-row>
            <vs-row class="ps_row">
                <vs-col>
                    <vs-input placeholder="Password" id="password" type="Password" v-model="password"/>
                </vs-col>
            </vs-row>
            <vs-row class="ps_row">
                <vs-col class="ps_col">
                    <vs-input type="submit" class="vs-button" color="darkgreen" color-text="black" value="Log in"/>
                </vs-col>
            </vs-row>
            <vs-alert color="danger" v-if="error">
                {{error_msg}}
            </vs-alert>
            </form>
        </vs-card>
    </vs-col>
</vs-row>
</template>
<script>
import axios from 'axios'
export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            error_msg: '',
            error: false
        }
    },
    methods: {
        login(){
        const url_api =  this.$store.state.url_api
        axios.post(url_api + 'logins', {
            email: this.email,
            password: this.password
        })
        .then(response => {
            this.error = false
            localStorage.setItem('token', response.data.access_token)
            this.$router.push('starterkit')

        })
        .catch(error => {
            this.error_msg = error.response.data
            this.error = true
        })
        }
    }
}
</script>
<style>
    .ps_row{
        margin-top: 10px;
    }
    .ps_col_card {
        text-align: -webkit-center;
        width: fit-content !important;
        margin-top: 80px;
    }
    .ps_col {
        text-align: center;
    }
    .vs-input--input {
    color: darkgreen;
    }
</style>